import request from "../utils/request";

export const getCategories = '/product/category/top';

export function getCategoriesDict (){
    return request.get('/product/category/top',{params:{}});
}

export function modifyCategory(values: any) {
    return request.request({
        url: '/product/category/',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function deleteCategory(categoryId: number) {
    return request.delete('/product/category/', {params: {categoryId}})

}